import churnPartner from './churn-partner'

export default [
  ...churnPartner,
]
